<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-items-center">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-w-1/2 wf-text-xs wf-tracking-wide" v-text="text"></span>
    <input
      v-model="value"
      type="text"
      class="wf-w-1/2 wf-text-right focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
    />
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    props: {
      text: {
        type: String,
        required: false,
        default: 'text'
      },
      property: {
        type: String,
        required: false,
        default: 'text'
      }
    },
    computed: {
      value: {
        get() {
          return this.elementContent[this.property]
        },
        set: _.debounce(function (value) {
          let object = new Object
          this.$set(object, this.property, value)
          this.addToObject(this.module, object, 'content', null, {}, true, this.parentModule)
        }, 500)
      },
    }
  })
</script>
